<template>
  <Container type="card-full">
    <!-- <div slot="header" v-if="type===1 || type ===2">
      <el-button @click="close">关闭</el-button>
    </div> -->
    <div slot="header">
        <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="" >{{btn.btnname}}</vxe-button>
    </div>
    <div>
      <div class="view-container" v-if="project">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{project.projectcode}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{project.projectname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">报价开始</div>
            <div class="view-value">{{project.prsbjbegtime | newDate}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-alertmsg"><span>注意：请及时审核供应商报名，竞价开始后，您将无法对供应商的报名信息进行审核</span></div>
        </div>
        <!--<div class="view-row">-->
          <!--<div class="view-field">-->
            <!--<div class="view-label">报名费</div>-->
            <!--<div class="view-value">{{project.projectbmamt | qfwVal}}</div>-->
          <!--</div>-->

        <!--</div>-->
        <!--<div class="view-row">-->
          <!--<div class="view-field">-->
            <!--<div class="view-label">保证金</div>-->
            <!--<div class="view-value">{{project.projectbzjamt | qfwVal}}</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
    </div>
      <div class="split-line"></div>
    </div>
        <vxe-table
          border
          :data="list">
          <vxe-table-column type="index" title="行号" width="60"></vxe-table-column>
          <vxe-table-column field="comfullname" title="供应商"></vxe-table-column>
          <vxe-table-column field="psutime" title="报名时间" formatter="toDateString"></vxe-table-column>
          <vxe-table-column field="psustatusdesc" title="状态"></vxe-table-column>
          <vxe-table-column field="" title="操作">
            <template slot-scope="scope">
              <el-button v-if="+scope.row.psustatus === 1"
                size="small"
                @click="view(scope.row,1)">审核
              </el-button>
              <el-button  v-else
                          size="small"
                          @click="view(scope.row, 3)">查看
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import dayjs from 'dayjs'
  export default {
    name: "psuConfirmForm",
    props: {
      cproject: Object,
      id: {},
      ctype: Number
    },
    filters:{
      newDate(value){
        return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      qfwVal(value) {
        return utils.comdify(value)
      }
    },
    data () {
      return {
        project: {},
        btnLoading: false,
        list: [],
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80},
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
          {
            field: 'psutime',
            fieldtype: 'T',
            title: '报名时间',
            calculExpr: '',
            addNewRowFlg: false,
            formatter: ['toDateString', '']
          },
          {field: 'psubmpayurl', fieldtype: 'C', type: 'html', title: '报名费', calculExpr: '', addNewRowFlg: false},
          {field: 'psubzjpayurl', fieldtype: 'C', type: 'html', title: '保证金', calculExpr: '', addNewRowFlg: false},
          {field: 'psuappends', fieldtype: 'C', type: 'html', title: '报名文件', calculExpr: '', addNewRowFlg: false}
        ]
      }
    },
    created () {
      this.getPageList()
    },
    activated () {
      this.getPageList()
    },
    watch: {
      id () {
        this.init()
        this.getPageList()
      }
    },
    components: {vggrid},
    computed: {},
    methods: {
      async view (row, flg) {
        if (flg === 1) {
          let nowdate = await request({
            method: 'get',
            url: 'xtgl/sysdata'
          })
          // 报价开始之前可以审核
          if (dayjs(this.project.prsbjbegtime).valueOf() < dayjs(nowdate).valueOf()) {
            this.$message.warning(`项目已进入报价阶段不能审核报名!`)
            return
          }
          // if (new Date(nowdate).getTime() < new Date(row.prsbmendtime).getTime()) {
          //   this.$message.warning('项目报名时间尚未结束，不能确认!')
          //   return
          // }
        }
        this.$router.push({name: 'psuBmForm', params: {psuid: row.psuid, type: flg}})
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuConfirmList',
          params: {projectid: this.$route.params.projectid}
        })
        this.list = res
        this.loading = false
        this.project = res[0]
        let nowdate = await request({
          method: 'get',
          url: 'xtgl/sysdata'
        })
        // 报价开始之前可以审核，
        if (dayjs(this.project.prsbjbegtime).valueOf() < dayjs(nowdate).valueOf()) {
          // 项目已进入报价阶段不能审核报名
          this.project.shflag = 1
        } else {
          this.project.shflag = 2
        }
      },
      async addOrEdit () {
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'psuConfirmIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .outline-box {
    border: 1px solid #000;
    margin-bottom: 10px;
  }
</style>
